<sl-titulo>{{ tituloDeslogueado | easyplaceholder: "Registro" }}</sl-titulo>

<ndc-dynamic [ndcDynamicComponent]="component" [ndcDynamicInputs]="inputs" [ndcDynamicOutputs]="outputs"></ndc-dynamic>
